
import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">

        <p>&copy; 2025 <strong>TestYodha</strong>. All rights reserved.</p>

        <p>
          📺 Subscribe on{' '}
          <a href="https://www.youtube.com/@faujdardefenceacademy723" target="_blank" rel="noreferrer">
            YouTube
          </a>
        </p>

        {/* Address & Contact */}
        <p className="contact-line">
          📍 Nagla Mahour, Rithori Karta, Agra, Uttar Pradesh - 283124
        </p>
        <p className="contact-line">
          📞 +91 70604 18100
        </p>

        <hr className="footer-line" />

        <p className="disclaimer">
          Disclaimer: TestYodha is an educational platform designed to support students in their preparation journey.
          All content is for academic purposes only. We do not guarantee selection but aim to enhance learning outcomes.
        </p>

        <p style={{ marginTop: '40px', fontStyle: 'italic', color: '#aaa' }}>
          Built with ❤️ by{' '}
          <a
            href="https://alphadevelopers.tech/"
            target="_blank"
            rel="noreferrer"
            style={{ color: '#61dafb', textDecoration: 'none' }}
          >
            Alpha Developers
          </a>{' '}
          | Powered by Purpose
        </p>
      </div>
    </footer>
  );
}

export default Footer;